export const AGENT_PHONE_SEARCH_MIN_DIGITS = 3;
export const AGENT_FUZZY_MIN_TOKEN_LENGTH = 4;
export function normalizeSearchText(value) {
    return value
        .toLocaleLowerCase('ru')
        .replace(/ё/g, 'е')
        .replace(/[^0-9a-zа-я]+/gi, ' ')
        .trim()
        .replace(/\s+/g, ' ');
}
export function extractPhoneDigits(raw) {
    return raw.replace(/\D/g, '');
}
function editDistanceOne(a, b) {
    if (a === b)
        return true;
    const lenA = a.length;
    const lenB = b.length;
    if (Math.abs(lenA - lenB) > 1)
        return false;
    let i = 0;
    let j = 0;
    let edits = 0;
    while (i < lenA && j < lenB) {
        if (a[i] === b[j]) {
            i += 1;
            j += 1;
            continue;
        }
        edits += 1;
        if (edits > 1)
            return false;
        if (lenA > lenB) {
            i += 1;
        }
        else if (lenB > lenA) {
            j += 1;
        }
        else {
            i += 1;
            j += 1;
        }
    }
    if (i < lenA || j < lenB)
        edits += 1;
    return edits <= 1;
}
function tokenMatchesField(token, field) {
    if (!token || !field)
        return false;
    if (field.includes(token))
        return true;
    const words = field.split(' ').filter(Boolean);
    for (const word of words) {
        if (word.startsWith(token))
            return true;
        if (token.length >= AGENT_FUZZY_MIN_TOKEN_LENGTH &&
            editDistanceOne(token, word)) {
            return true;
        }
    }
    return false;
}
function agentSearchFields(agent) {
    return [
        normalizeSearchText(agent.displayName ?? ''),
        normalizeSearchText(agent.agencyName ?? ''),
        normalizeSearchText(agent.assignedManagerName ?? ''),
    ].filter(Boolean);
}
function isDigitToken(token) {
    return /^\d+$/.test(token);
}
export function matchesAgentSearch(agent, query) {
    const trimmed = query.trim();
    if (trimmed === '')
        return true;
    const fields = agentSearchFields(agent);
    const agentPhoneDigits = extractPhoneDigits(agent.phone ?? '');
    const phoneDigits = extractPhoneDigits(trimmed);
    const fullPhoneMatch = phoneDigits.length >= AGENT_PHONE_SEARCH_MIN_DIGITS &&
        agentPhoneDigits.includes(phoneDigits);
    const tokens = normalizeSearchText(trimmed).split(' ').filter(Boolean);
    const textTokens = tokens.filter((token) => !isDigitToken(token));
    const digitTokens = tokens.filter((token) => isDigitToken(token));
    if (textTokens.length === 0) {
        return fullPhoneMatch;
    }
    const textOk = textTokens.every((token) => fields.some((field) => tokenMatchesField(token, field)));
    if (!textOk)
        return false;
    if (digitTokens.length === 0)
        return true;
    if (fullPhoneMatch)
        return true;
    return digitTokens.every((token) => {
        if (token.length < AGENT_PHONE_SEARCH_MIN_DIGITS)
            return false;
        return agentPhoneDigits.includes(token);
    });
}
export function searchAgents(agents, query) {
    const trimmed = query.trim();
    if (trimmed === '')
        return agents;
    return agents.filter((agent) => matchesAgentSearch(agent, trimmed));
}
